/**
 * Extracts the pathname + search from a URL string.
 * If the URL is absolute, returns just the path portion so that
 * axios uses the configured baseURL and auth interceptors.
 * If already relative, returns as-is.
 */
export const getUrlPath = (url: string | undefined): string => {
  if (!url) return '';
  try {
    const urlObj = new URL(url);
    return urlObj.pathname + urlObj.search;
  } catch {
    return url;
  }
};
